import Helper from '../../lib/Helper';

export default {
	_config : null,
	_toggles: null,
	init(appConfig, reloaded) {
		this._config  = appConfig;
		this._toggles = document.querySelectorAll('[data-products-load-more]');
		if (!this._toggles.length) {
			return;
		}
		Array.prototype.forEach.call(this._toggles, toggle => {
			const list = document.querySelector(`[data-products-list="${toggle.getAttribute('data-products-load-more')}"]`);
			if (list) {
				list.style.maxHeight = '0';
			}
			toggle.addEventListener('click', this._onClick.bind(toggle));
		});
	},
	reload() {
		this.init(this._config, true);
	},
	_onClick(e) {
		e.stopPropagation();
		e.preventDefault();
		const UUID   = this.getAttribute('data-products-load-more');
		const list   = document.querySelector(`[data-products-list="${UUID}"]`);
		const slider = document.querySelector(`[data-products-slider="${UUID}"]`);
		if (list) {
			list.style.maxHeight = `${Helper.getElementHeight(list)}px`;
			list.classList.add('products__list--active');
		}
		if (slider) {
			slider.style.display = 'none';
		}
		this.style.display = 'none';
	}
};